import React, { useEffect, useState } from "react";
import * as S from "./popularCarRoutes.styles";
import Icon from "../../../../core-components/IconsSelector";
import { getLoadedComponent } from "../../../../../shared/config/omni";

interface PopularRoutesProps {
  popularRoutes: Array<IRoutes>;
}
interface IRoutes {
  list?: Array<IList>;
  title?: string;
}
interface IList {
  heading?: string;
  routeList?: Array<IRouteList>;
}
interface IRouteList {
  link?: string;
  title?: string;
}

const PopularCarRoutes: React.FC<PopularRoutesProps> = ({ popularRoutes }) => {
  const [index, setIndex] = useState(0);
  const list = popularRoutes?.[index]?.list || [];

  useEffect(() => {
    getLoadedComponent('PopularCarRoutes')
  }, [])

  if (!(list?.length)) return null;
  return (
    <S.PopularBusRoutes>
      <h3>Popular Cars routes</h3>
      <S.RouteBlock>
        <S.Tabs>
          <S.TabListUl>
            {popularRoutes.map(({ title }, key) => <li className={index === key ? "active" : ""} onClick={() => setIndex(key)} key={`tabui${key}`}>{title}</li>) || null}
          </S.TabListUl>
        </S.Tabs>
        <S.RouteListUl>
          {(list.map(({heading, routeList}, index) => (
            <li key={`Route${index}`}>
              <S.BusIcon>
                <Icon
                  name="CarWithBgIcon"
                  styleProps={{ width: "3rem", height: "3rem" }}
                />
              </S.BusIcon>
              <S.BusDetails>
                <S.CardHeader>{heading}</S.CardHeader>
                
                <S.SmallTxt>
                  {(routeList.map(({ link, title }, index) => (<a href={link} key={`SmallTxt${index}`}>{(index === routeList.length - 1) ? title : `${title}, `}</a>)))}
                </S.SmallTxt>
              </S.BusDetails>
            </li>
          ))) || null}
        </S.RouteListUl>
      </S.RouteBlock>
    </S.PopularBusRoutes>
  );
};
export default PopularCarRoutes;
